import { SwipeAction } from "antd-mobile";
import { DeleteIcon } from "./DeleteIcon";
import { DataRow } from "pages/meter/components";
import { IDataRow } from "pages/meter/types";

type IDataListProps = {
  data: IDataRow[];
  onDelete: (data: IDataRow) => void;
  onToDetailPage: (data: IDataRow) => void;
};

export const DataList = ({ data, onToDetailPage,onDelete }: IDataListProps) => {
  if (!data || data.length === 0) {
    return null;
  }
  return (
    <>
      {data.map((item, index) => (
        <div
          className="bg-white dark:bg-black333 rounded-[8px] mb-[10px]"
          key={index}
        >
          <SwipeAction
            className="rounded-[8px] bg-transparent"
            rightActions={[
              {
                key: "delete",
                onClick: (e) => onDelete(item),
                text: (
                  <div className="px-3">
                    <DeleteIcon />
                  </div>
                ),
                color: "#FF5454",
              },
            ]}
            key={index}
          >
            <DataRow data={item} onClick={() => onToDetailPage(item)} />
          </SwipeAction>
        </div>
      ))}
    </>
  );
};
